import type { ActivityPeriod, ActivityResult } from '@services/activity.service';

export const PERIOD_OPTIONS: ActivityPeriod[] = ['1d', '7d', '30d', '90d'];

export const RESULT_OPTIONS: Array<'' | ActivityResult> = ['', 'success', 'failure', 'error'];

/**
 * Radix throws on `value=""`, which is what both filters use for "all". The
 * sentinel never leaves this module's mapping helpers, so the value handed to
 * activityService stays exactly the '' | value the MUI page sent.
 */
export const ALL_FILTER = '__activity_filter_all__';

export const toSelectValue = (filter: string): string => (filter === '' ? ALL_FILTER : filter);

export const fromSelectValue = (value: string): string => (value === ALL_FILTER ? '' : value);
